// Who may CHANGE Private Money settings — the person half of the gate.
//
// CONSUMER: both. The server gate (workers/api/src/routes/pm-guidelines.ts,
// pm-fund.ts, pm-underwriting.ts) and the screens that hide the edit
// buttons import THIS list, so the page and the server cannot disagree
// about who is in.
//
// Grant's call, 2026-09-23 (the Private Money audit, access batch): writes
// to Mike's rules, the lenders' standing terms, the fund book, credit
// scores and each loan's underwriting are "Mike, Cole, Grant and Baker."
// Reading stays exactly as it was — everyone with Mortgage access sees
// everything.
//
// WHY PEOPLE, NOT A ROLE. The Mortgage company scope covers Joey and
// Cambria (and the no-limit accounts cover Donna), and until now every one
// of them could change a number Mike underwrites to. There is no role that
// means "Private Money": Mike and Cole share `advisor` with every other
// advisor. So, like the fee review, the people are named by sign-in email.
//
// This supersedes the pm-guidelines.ts reasoning that a narrower test
// "would strand Cole the moment Mike is on a plane" — Cole is on this
// list, which answers the same worry.
//
// system_admin is admitted by role as well as by name (today that is
// Grant and Baker), so an admin account with a different address is not
// locked out of fixing a Private Money setting.
//
// Adding a person is a one-line change here, reviewed like any other
// access change.
//
// 2026-10-18: Baker and Grant are both on the operations desk
// (shared/ops-desk/members.ts) until Baker's role change is scheduled; this
// access list is unchanged and stays a separate decision.

export const PM_EDITOR_EMAILS: readonly string[] = [
  "mike@stewardship.pro",
  "cole@stewardship.pro",
  "grant@stewardship.pro",
  "baker@stewardship.pro",
];

/** Who to name when someone else tries: the people who can change it. */
export const PM_EDITOR_NAMES = "Mike, Cole, Grant or Baker";

export function isPmEditor(who: { email: string | null | undefined; roleSlug: string | null | undefined }): boolean {
  if (who.roleSlug === "system_admin") return true;
  const email = (who.email ?? "").trim().toLowerCase();
  return email !== "" && PM_EDITOR_EMAILS.includes(email);
}

/** The refusal every gated write returns, in words a person can act on. */
export function pmEditorDenial(): { error: "pm_editor_only"; message: string } {
  return {
    error: "pm_editor_only",
    message: `Only ${PM_EDITOR_NAMES} can change Private Money settings. Ask one of them to make this change.`,
  };
}
